
import { Vue, Prop, Component } from "vue-property-decorator";
import SelfScheduleDefaultShift from './self-schedule-default-shift.model';

@Component
export default class SelfScheduleDefault extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() tenantId!: string;
    @Prop() staffId!: number;
    @Prop() first!: string;
    @Prop() last!: string;
    @Prop() hasDefaultSelfScheduleApplied!: boolean;
    @Prop() defaultSelfScheduleAppliedDate!: Date;
    @Prop() defaultShifts !: SelfScheduleDefaultShift[];
}
